import PropTypes from 'prop-types'
import React from 'react'
import Scroll from 'components/Scroll'
import { View } from 'components/View'

class List extends React.Component {
  renderBody () {
    if (!this.props.onLoadMoreItems) {
      return this.renderItems()
    }
    return this.renderScrollableItems()
  }

  renderItems () {
    return (
      <View
        style={{
          flexDirection: this.props.direction,
          WebkitOverflowScrolling: 'touch',
          overflowX: this.props.direction === View.DIRECTION.ROW
            ? 'scroll'
            : null,
          overflowY: this.props.direction !== View.DIRECTION.ROW
            ? 'scroll'
            : null,
          flexWrap: (this.props.direction === View.DIRECTION.ROW && (!this.props.shouldNotWrap && !this.props.shouldScroll)) ? 'wrap' : null
        }}
      >
        {this.props.children}
      </View>
    )
  }

  renderScrollableItems () {
    const props = {
      pathname: this.props.pathname,
      direction: this.props.direction,
      shouldNotWrap: this.props.shouldNotWrap,
      isBoundToWindow: this.props.isBoundToWindow,
      isHorizontal: this.props.isHorizontal,
      onReachedEnd: this.props.onLoadMoreItems
    }
    return (
      <Scroll {...props}>
        {this.props.children}
      </Scroll>
    )
  }

  render () {
    return (
      <>
        {this.renderBody()}
      </>
    )
  }
}

List.DIRECTION = View.DIRECTION
List.defaultProps = {
  isBoundToWindow: true,
  direction: View.DIRECTION.COLUMN
}
List.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  /**
   * The current pathname.
   * Used to re-init the <Scroll>
   * NOTE: not provided if onLoadMoreItems is null.
   * @type {String|null}
   */
  pathname: PropTypes.string,
  isBoundToWindow: PropTypes.bool,
  shouldScroll: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  direction: PropTypes.string,
  onLoadMoreItems: PropTypes.func,
  shouldNotWrap: PropTypes.bool
}
export default List
